// extracted by mini-css-extract-plugin
export var footer = "_o2-5";
export var fulfillmentInput = "_o2-0";
export var shipDateInput = "_o2-1";
export var shipmentModal = "_o2-2";
export var shipmentModalContent = "_o2-3";
export var tableContainer = "_o2-4";